import React, { useEffect } from "react";
import Login from "../components/pages/Login";
import Main from "../components/pages/Main";
import GoogleAnalistics from "../components/analistics/GoogleAnalistics";
import { performance } from "../firebase";
import { Routes, Route, useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { productNoState } from "../states/poductNoState";

const createProductNo = (productNo) => {
  // 空文字やnullの場合の処理
  if (!productNo || productNo.trim() === "") {
    return { productNo: "", productBno: "" };
  }

  const productNoArr = productNo.split("-");
  console.log("productNoArr", productNoArr, productNoArr[1]);

  // 数値を指定桁数で0埋めする関数
  const padZero = (num, length) => {
    return (num || "").toString().padStart(length, "0");
  };

  // '-'だけの場合の処理
  if (
    productNoArr.length === 2 &&
    productNoArr[0] === "" &&
    productNoArr[1] === ""
  ) {
    return { productNo: "", productBno: "" };
  }

  // '00-'の場合の処理
  if (productNoArr.length === 2 && productNoArr[0] !== "" && !productNoArr[1]) {
    return { productNo: padZero(productNoArr[0], 8), productBno: "" };
  }

  // '-00'の場合の処理
  if (
    productNoArr.length === 2 &&
    productNoArr[0] === "" &&
    productNoArr[1] !== ""
  ) {
    return { productNo: "", productBno: padZero(productNoArr[1], 2) };
  }

  // 通常の場合の処理
  if (productNoArr.length === 2) {
    return {
      productNo: padZero(productNoArr[0], 8),
      productBno: padZero(productNoArr[1], 2),
    };
  }

  // '-'が含まれない場合の処理
  return {
    productNo: padZero(productNo, 8),
    productBno: "",
  };
};
const Router = () => {
  const search = useLocation().search;
  const setProductNoState = useSetRecoilState(productNoState);
  const query = new URLSearchParams(search);
  let productNoFromQuery = "";
  productNoFromQuery = query.get("productNo") ?? "";
  useEffect(() => {
    console.log("productNoFromQuery", productNoFromQuery);
    const { productNo, productBno } = createProductNo(productNoFromQuery);
    console.log("productNoFromQuery", productNo, productBno);
    setProductNoState({
      productNo,
      productBno,
    });
  }, []);

  return (
    <GoogleAnalistics>
      <Routes>
        <Route path={"/"} element={<Main />} />{" "}
        <Route path={"/login"} element={<Login />}></Route>
      </Routes>
    </GoogleAnalistics>
  );
};

export default Router;
